<div class="np-form-control dx-fieldset dpb">
  <div class="row g-3">
    <div class="col-12">
      <dx-validation-group id="DPB" class="d-flex flex-column">

        <div class="col-12 p-2">
          <div class="np-field">
            <np-inputControl [showPlaceLabel]="model?.descriptionShort2?.length > 0"
                             [model]="model"
                             field="DESCRIPTION_SHORT_2"
                             labelText="{{ 'DESCRIPTION_SHORT_2' | translate }}">
              <div class="contentSlot" slot="content">
                <dx-text-box (onValueChanged)="update($event)"
                             [(value)]="model.descriptionShort2"
                             [readOnly]="readOnly()"
                             [showClearButton]="true">
                  <dx-validator *ngIf="!templateView && model?.id"
                                validationGroup="DPB"
                                (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField('DESCRIPTION_SHORT_2')"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </np-inputControl>
          </div>
        </div>

        <div class="col-12 p-2">
          <div class="np-field">
            <np-inputControl [showPlaceLabel]="model?.descriptionShort3?.length > 0"
                             [model]="model"
                             field="DESCRIPTION_SHORT_3"
                             labelText="{{ 'DESCRIPTION_SHORT_3' | translate }}">
              <div class="contentSlot" slot="content">
                <dx-text-box (onValueChanged)="update($event)"
                             [(value)]="model.descriptionShort3"
                             [readOnly]="readOnly()"
                             [showClearButton]="true">
                  <dx-validator *ngIf="!templateView && model?.id"
                                validationGroup="DPB"
                                (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField('DESCRIPTION_SHORT_3')"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </np-inputControl>
          </div>
        </div>

        <div class="col-12 p-2">
          <div class="np-field">
            <np-inputControl [showPlaceLabel]="model?.descriptionShort4?.length > 0"
                             [model]="model"
                             field="DESCRIPTION_SHORT_4"
                             labelText="{{ 'DESCRIPTION_SHORT_4' | translate }}">
              <div class="contentSlot" slot="content">
                <dx-text-box (onValueChanged)="update($event)"
                             [(value)]="model.descriptionShort4"
                             [readOnly]="readOnly()"
                             [showClearButton]="true">
                  <dx-validator *ngIf="!templateView && model?.id"
                                validationGroup="DPB"
                                (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField('DESCRIPTION_SHORT_4')"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </np-inputControl>
          </div>
        </div>

        <div *ngIf="loginService.hasAddonBauvista" class="col-12 p-2">
          <div class="np-field">
            <np-inputControl [showPlaceLabel]="model?.matchcode?.length > 0"
                             [model]="model"
                             field="MATCHCODE"
                             labelText="{{ 'MATCHCODE' | translate }}">
              <div class="contentSlot" slot="content">
                <dx-text-box (onValueChanged)="update($event)"
                             [(value)]="model.matchcode"
                             [readOnly]="readOnly()"
                             [showClearButton]="true">
                  <dx-validator *ngIf="!templateView && model?.id"
                                validationGroup="DPB"
                                (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField('MATCHCODE')"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </np-inputControl>
          </div>
        </div>

      </dx-validation-group>
    </div>
  </div>
</div>
